import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Helpers } from "../../auth/helpers";

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    constructor() {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authHeader = '';
        let token = Helpers.getSessionStorage('id_token');

        if (token) {
            authHeader = 'Bearer ' + token;
        }

        request = request.clone({
            setHeaders: {
                'Authorization': authHeader,
                'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Content-Type': 'application/json'
            }
        });

        return next.handle(request);
    }
}